export default "__VITE_ASSET__0b19a7ae__"